// extracted by mini-css-extract-plugin
module.exports = {"hasDiscount":"sz","isSRPPage":"sA","blue":"sB","red":"sC","yellow":"sD","violet":"sE","orange":"sF","gold":"sG","stroke_black":"sH","stroke_green":"sI","stroke_white":"sJ"};